export class Browser {

    location(): string {
        return window.location.href;
    }

    userAgent(): string {
        return window.navigator.userAgent;
    }

    isCookiesEnabled(): boolean {
        return window.navigator.cookieEnabled;
    }

    language(): string {
        return window.navigator.language;
    }

    getQueryStringParam(key: string): string | null {
        if (URLSearchParams) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(key);
        }
        const url = window.location.href;
        let name = key.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    gotoUrl(url: string, queryStringParams?: {}) {
        const newUrl = this.createRoute(url, queryStringParams);
        window.location.href = newUrl;
    }

    createRoute(url: string, queryStringParams?: {}): string {
        var newUrl = url;
        if (queryStringParams) {
            const queryString = this.constructQueryStringParamsFromObject(queryStringParams);
            if (queryString !== '') {
                if (newUrl.indexOf('?') >= 0) {
                    newUrl += '&' + queryString;
                }
                else {
                    newUrl += '?' + queryString;
                }
            }
        }
        return newUrl;
    }

    refreshPage() {
        window.location.reload();
    }

    goBack() {
        window.history.back();
    }

    private constructQueryStringParamsFromObject(params: {}) {
        var query = Object.keys(params)
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
            .join('&');
        return query;
    }
}